import Seo from "@/components/Seo";
import Contact from "@/components/landing/Contact";

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact Almeida's Home Services | Free Estimate in Charlotte, NC"
        description="Request a free, no-obligation remodeling estimate in Charlotte, Pineville, Matthews, Fort Mill & Rock Hill. Call (704) 390-4489 or send a message."
        path="/contact"
      />
      <div className="pt-20">
        <Contact />
      </div>
    </>
  );
}
